import React from 'react'
import { connect } from 'react-redux'
import { formValueSelector } from 'redux-form'

const selector = formValueSelector('VersantClaimForm')

function VersantSelectedServices({ selectedServices }) {
  return (
    <div className="bg-white border rounded p-5 sticky-top" style={{ top: '1rem', zIndex: 0 }}>
      <h6 className="mb-4">Selected Services</h6>
      {selectedServices.length === 0 ? (
        <p className="text-muted mb-0">No services selected</p>
      ) : (
        <ul className="list-unstyled mb-0">
          {selectedServices.map((service) => (
            <li key={service} className="mb-4 text-muted">
              {service}
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}

export default connect((state) => ({
  selectedServices: (selector(state, 'eligibility.data') || [])
    .filter((item) => item.active)
    .map((item) => item.service_type),
}))(VersantSelectedServices)
